export function priceForBudget(rangeGoals) {
  if (!rangeGoals) return null;

  const key = String(rangeGoals)
    .replace(/,/g, "")
    .replace(/\s+/g, "")
    .replace(/TO/gi, "-")
    .replace(/[\u2013\u2014]/g, "-")
    .toUpperCase();

  if (key.includes("10K") && key.includes("25K")) {
    return { fee: 100, code: "FIRST50", firstLeadDiscount: 50 };
  }

  if (key.includes("26K") || key.includes("35K") || key.includes("50K")) {
    return { fee: 100, code: "FIRST50", firstLeadDiscount: 50 };
  }

  if (key.includes("50K") && key.includes("75K")) {
    return { fee: 300, code: "FIRST150", firstLeadDiscount: 150 };
  }

  if (key.includes("76K") || key.includes("100K") || key.includes("+")) {
    return { fee: 500, code: "FIRST250", firstLeadDiscount: 250 };
  }

  return null;
}
